//パスワードの表示非表示の制御を行う
$(function () {
  $('.checkbox-input').click(function () {
    const id = $(this).attr('id');
    //同じ画面で同じidだと1つしか動作しなくなる(2020/11/26時点でチェックボックス3つが最大)
    if (id === 'show_password01' || id === 'show_password02' || id === 'show_password03') {
      if ($(this).prop('checked') == false) {
        $(this).closest('td').find(':text').attr('type', 'password')
      } else {
        $(this).closest('td').find(':password').attr('type', 'text')
      }
    }
  });
});
